import React from 'react'
import { connect } from 'react-redux'
import { Chart, ErrorBoundary } from 'components'
import { getGoalPath } from 'store/selectors'

function Goalpath(props) {
  const { goalPath, investments } = props
  return (
    <div className="goalpath">
      <ErrorBoundary>
        <div>
          <h5>Planned Goal Path</h5>
          <div className="goalpath__legend" />
        </div>
        <Chart
          data={goalPath}
          xLabel="Age"
          yLabel="Portfolio Value"
          secondary={investments}
          secondaryLabel="Monthly Investment"
          editPanelOpen
        />
      </ErrorBoundary>
    </div>
  )
}

export default connect(state => ({
  ...getGoalPath(state),
}))(Goalpath)

// BUG: Sends empty goal when no active go



// WEBPACK FOOTER //
// ./src/components/layout/Goalpath.js